module.exports = __webpack_public_path__ + "static/media/2_pl.c1f9bd6f.png";